import { Text, Flex, Spinner, Img, BoxProps } from '@chakra-ui/react';
import { clientEndpoints } from '@texas/clientEndpoints';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';

interface Props extends BoxProps {
  identifier: string;
  size: number;
}

export function ImageLoadingState({ identifier, size, ...props }: Props) {
  const [loaded, setLoaded] = useState(false);
  const { t } = useTranslation();
  return (
    <Flex {...props}>
      {!loaded && (
        <Flex
          flexGrow={1}
          margin="auto"
          gap={2}
          p={2}
          align="center"
          justify="center"
          flexDir="column"
        >
          <Spinner />
          <Text variant="small">{t('fileBrowser.loadingImage')}</Text>
        </Flex>
      )}
      <Img
        onLoad={() => setLoaded(true)}
        src={clientEndpoints.previewImage(identifier, size)}
      />
    </Flex>
  );
}
